import { render, staticRenderFns } from "./LayoutNavigationGroup.vue?vue&type=template&id=5bcf1474&"
import script from "./LayoutNavigationGroup.vue?vue&type=script&lang=js&"
export * from "./LayoutNavigationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bcf1474')) {
      api.createRecord('5bcf1474', component.options)
    } else {
      api.reload('5bcf1474', component.options)
    }
    module.hot.accept("./LayoutNavigationGroup.vue?vue&type=template&id=5bcf1474&", function () {
      api.rerender('5bcf1474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/layout/LayoutNavigationGroup.vue"
export default component.exports